import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, CheckCircle2, AlertCircle, XCircle } from "lucide-react";

const ST = {
  HEALTHY: { Icon: CheckCircle2, c: "text-accent", bg: "bg-accent/10 border-accent/20" },
  WARNING: { Icon: AlertCircle, c: "text-primary", bg: "bg-primary/10 border-primary/20" },
  ERROR: { Icon: XCircle, c: "text-destructive", bg: "bg-destructive/10 border-destructive/20" },
};

export default function Tracking() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/tracking-health").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  const counts = items.reduce((a, i) => ({ ...a, [i.status]: (a[i.status] || 0) + 1 }), {});

  return (
    <div className="space-y-6 animate-float-up" data-testid="tracking-panel">
      <div className="grid grid-cols-3 gap-4">
        {[["HEALTHY", "Healthy"], ["WARNING", "Warning"], ["ERROR", "Error"]].map(([k, l]) => {
          const s = ST[k];
          return (
            <div key={k} className={`rounded-2xl border p-5 text-center ${s.bg}`}>
              <p className={`font-display text-3xl font-extrabold ${s.c}`}>{counts[k] || 0}</p>
              <p className="text-xs text-muted-foreground mt-1">{l}</p>
            </div>
          );
        })}
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {items.map((i) => {
          const s = ST[i.status];
          return (
            <div key={i.id} data-testid={`tracking-${i.id}`} className="bg-card border border-border rounded-xl p-4 flex items-center justify-between">
              <span className="text-sm">{i.name}</span>
              <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${s.c}`}><s.Icon className="w-4 h-4" />{i.status}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
